"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toFlexDirection = toFlexDirection;
exports.toFlexJustifyOrAlignment = toFlexJustifyOrAlignment;
exports.paddingFromProps = paddingFromProps;
exports.makePaddingString = makePaddingString;

function toFlexDirection(direction) {
  switch (direction) {
    case "vertical":
      return "column";

    case "horizontal":
      return "row-reverse";

    default:
      return "row";
  }
}

function toFlexJustifyOrAlignment(distribution) {
  switch (distribution) {
    case "start":
      return "flex-start";

    case "end":
      return "flex-end";

    default:
      return distribution;
  }
}

function paddingFromProps(props) {
  const {
    paddingPerSide,
    padding = 0,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight
  } = props;

  if (paddingPerSide !== false && (paddingTop !== undefined || paddingBottom !== undefined || paddingLeft !== undefined || paddingRight !== undefined)) {
    return {
      top: paddingTop !== undefined ? paddingTop : padding,
      bottom: paddingBottom !== undefined ? paddingBottom : padding,
      left: paddingLeft !== undefined ? paddingLeft : padding,
      right: paddingRight !== undefined ? paddingRight : padding
    };
  }

  return {
    top: padding,
    bottom: padding,
    left: padding,
    right: padding
  };
}

function makePaddingString({
  top,
  left,
  bottom,
  right
}) {
  return `${top}px ${right}px ${bottom}px ${left}px`;
}